import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import MenuAge from "./components/main/menu/MenuAge";
import MenuSkill from "./components/main/menu/MenuSkill";
import ContentList from "./components/main/content/ContentList";
import ContentDetail from "./components/main/content/card/layout/ContentDetail";
import Header from "./components/main/layout/Header";
import Login from "./components/main/authentication/Login";
import Register from "./components/main/authentication/Register";
import Sessioncheck from "./components/main/authentication/Sessioncheck";
import AddContent from "./components/main/content/card/modify/AddContent";
import EditContent from "./components/main/content/card/modify/EditContent";
import DeleteContent from "./components/main/content/card/modify/DeleteContent";
import { UserProvider } from "./services/UserContext";
import { AlertProvider } from "./services/AlertContext";

function App() {
  return (
    <>
      <BrowserRouter>
        <UserProvider>
          <AlertProvider>
            <Header />
            <main className="page">
              <div className="page__container">
                <Routes>
                  <Route path="/" element={<MenuAge />} />
                  <Route path="skill" element={<MenuSkill />} />
                  <Route path="list" element={<ContentList />} />
                  <Route path="detail" element={<ContentDetail />} />
                  <Route path="login" element={<Login />} />
                  <Route path="register" element={<Register />} />
                  <Route path="session" element={<Sessioncheck />} />
                  <Route path="new" element={<AddContent />} />
                  <Route path="edit" element={<EditContent />} />
                  <Route path="delete" element={<DeleteContent />} />
                </Routes>
              </div>
            </main>
            <footer className="footer"></footer>
          </AlertProvider>
        </UserProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
